import React from 'react';
import { 
  Phone, 
  CheckCircle, 
  XCircle, 
  PhoneMissed 
} from 'lucide-react';

export const DashboardStatsView = ({ stats }) => {
  
  // Reusable Stat Card Component
  const StatCard = ({ title, value, icon: Icon, colorClass, bgClass }) => (
    <div className="flex h-full min-h-[152px] flex-col items-center justify-center rounded-2xl border border-zinc-200 bg-white p-5 text-center shadow-sm transition-all duration-300 hover:-translate-y-1 hover:shadow-md dark:border-zinc-800 dark:bg-black">
      <div className={`w-12 h-12 rounded-full flex items-center justify-center mb-3 ${bgClass}`}>
        <Icon size={24} className={colorClass} />
      </div>
      <h3 className="mb-1 text-2xl font-bold text-zinc-900 dark:text-white">
        {value}
      </h3>
      <p className="text-xs font-semibold uppercase tracking-[0.2em] text-zinc-500 dark:text-zinc-400">
        {title}
      </p>
    </div>
  );

  return (
    <div className="grid w-full grid-cols-1 gap-4 sm:grid-cols-2 xl:grid-cols-4">
      
      {/* Total Calls */}
      <StatCard 
        title="Total Calls" 
        value={stats.totalCalls} 
        icon={Phone} 
        bgClass="bg-zinc-100 dark:bg-zinc-900"
        colorClass="text-zinc-900 dark:text-white"
      />

      {/* Answered Calls */}
      <StatCard 
        title="Answered" 
        value={stats.answeredCalls} 
        icon={CheckCircle} 
        bgClass="bg-zinc-200 dark:bg-zinc-800"
        colorClass="text-zinc-900 dark:text-zinc-100"
      />

      {/* Canceled Calls */}
      <StatCard 
        title="Canceled" 
        value={stats.cancelCalls} 
        icon={XCircle} 
        bgClass="bg-zinc-100 dark:bg-zinc-900"
        colorClass="text-zinc-700 dark:text-zinc-300"
      />

      {/* Missed Calls */}
      <StatCard 
        title="Missed" 
        value={stats.missCalls} 
        icon={PhoneMissed} 
        bgClass="bg-zinc-200 dark:bg-zinc-800"
        colorClass="text-zinc-700 dark:text-zinc-300"
      />

    </div>
  );
};

export default DashboardStatsView;
